import { render } from "./resolution-setup-area.vue?vue&type=template&id=1713233a"
import script from "./resolution-setup-area.vue?vue&type=script&lang=js"
export * from "./resolution-setup-area.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__